// extracted by mini-css-extract-plugin
export var st0 = "BlueBigLogo-module--st0--L4fSf";
export var st1 = "BlueBigLogo-module--st1--BkiR2";